import React from 'react'
import { useTranslation } from 'react-i18next'

import { CookieConsentOption } from 'root-constants'

import { TCookieConsentCategory } from '../../constants'
import { StyledCookieConsentPreferences as S } from './CookieConsentPreferences.styles'

type TCookieConsentCategoryItemProps = {
  category: TCookieConsentCategory
  normalizedConsentTypes: string[]
  onToggleCategory: (categoryKey: string) => void
}

export const CookieConsentCategory: React.FC<
  TCookieConsentCategoryItemProps
> = ({ category, normalizedConsentTypes, onToggleCategory }) => {
  const { t } = useTranslation()
  const { key, titleKey, subtitleKey, badgeKey } = category

  const isStrictlyNecessary = key === CookieConsentOption.STRICTLY_NECESSARY
  const isChecked = isStrictlyNecessary || normalizedConsentTypes.includes(key)

  return (
    <S.CategoryItem>
      <S.CategoryAccordion>
        <S.CategoryHeader $hasBadge={Boolean(badgeKey)}>
          <S.ExpandIcon aria-hidden="true" />
          <S.CategoryTitle>{t(titleKey)}</S.CategoryTitle>

          {badgeKey ? <S.StatusBadge>{t(badgeKey)}</S.StatusBadge> : null}
        </S.CategoryHeader>

        <S.CategoryDescription>{t(subtitleKey)}</S.CategoryDescription>
      </S.CategoryAccordion>

      {!isStrictlyNecessary && (
        <S.Toggle
          checked={isChecked}
          onChange={() => onToggleCategory(key)}
          onClick={(event) => {
            event.stopPropagation()
          }}
        />
      )}
    </S.CategoryItem>
  )
}
